import type { Slide } from '@core-api/presentation/types/response';
import { layoutToQuestionLayoutLegacy } from './layoutToQuestionLayoutLegacy';

/**
 * @deprecated Do not use or you will be haunted! Copy pasted from compatibility layer
 * Making the effort of converting a few helpers that depend on legacy layout the new domain is not worth it considering that
 * old content slides are going to be removed soon. Copy pasted compatibility layer instead.
 * This code should not be used and should be removed as soon as the legacy content slides are removed
 */
export const getLegacyLayout = ({
  staticContent,
}: {
  staticContent: Slide['staticContent'];
}) => {
  // TODO: static content should not be undefined here based on types. Leaving this check for now to avoid unintended consequences.
  if (!staticContent) {
    return undefined;
  }

  // leaderboard and pin-on-image are a special case, since it does not have a layout in the new model, but
  // it has textSizeOffset. The old model has whole layout object for leaderboard and pin-on-image, but all the properties are static
  // there except `font_size_offset`.
  // To make it backwards compatible, we set the same defaults for layout as in the old model.
  if (
    staticContent.type === 'leaderboard' ||
    staticContent.type === 'pin-on-image'
  ) {
    return {
      type: 'default',
      font_size_offset: staticContent.textSizeOffset,
      alignment_x: 1,
      alignment_y: 1,
      size: '33%',
    } as const;
  }

  // image and document do not have layout in the old model
  if (staticContent.type === 'image' || staticContent.type === 'document') {
    return null;
  }

  if (!('layout' in staticContent)) {
    return undefined;
  }

  const textAlignment =
    'textAlignment' in staticContent ? staticContent.textAlignment : undefined;

  const fontSizeOffset =
    'textSizeOffset' in staticContent ? staticContent.textSizeOffset : 0;

  return layoutToQuestionLayoutLegacy({
    layout: staticContent.layout,
    layoutPosition: staticContent.image?.imageLayoutPosition,
    inset: Boolean(staticContent.image?.imageInset),
    textAlignment,
    fontSizeOffset,
  });
};
